import { TableData } from '@/components/elements/Table';

// utils
import { addUniqueKey } from '@/utils';

/**
 * @function generateTableData
 * @param data table row data
 * @param parentChildData when called gets row's parent
 * @summary gets flat list of table data and convert it to tree with unique ids
 */
export function generateTableData<TableRowData extends Record<string, unknown>>(
  data: TableRowData[],
): TableData<TableRowData>[] {
  const uniqueData: TableData<TableRowData>[] = addUniqueKey<TableRowData>(
    data,
  );
  return uniqueData;
}
